module.exports = new __parcel__URL__("pvp_light_attack_button.3e9ae306.png").toString();